///////////////////////////////////// 
// TOP tab collection
/////////////////////////////////////

(() => {
  const ROOT_SELECTOR = '[data-tabs-collections]';

  const initOne = (root) => {
    if (!root || root.dataset.tabsInit === '1') return;

    const tabs = root.querySelectorAll('[role="tab"][data-tab]');
    const panels = root.querySelectorAll('[role="tabpanel"][data-panel]');
    if (!tabs.length || !panels.length) return;

    const activate = (tabId) => {
      tabs.forEach((t) => {
        const isActive = t.getAttribute('data-tab') === tabId;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach((p) => {
        const isActive = p.getAttribute('data-panel') === tabId;
        p.classList.toggle('is-active', isActive);
        p.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    };

    tabs.forEach((t) => {
      t.addEventListener('click', () => {
        const tabId = t.getAttribute('data-tab');
        if (!tabId) return;
        activate(tabId);
      });
    });

    root.dataset.tabsInit = '1';

    const activeBtn = root.querySelector('[role="tab"].is-active[data-tab]');
    const initialTab = activeBtn ? activeBtn.getAttribute('data-tab') : (tabs[0].getAttribute('data-tab') || '');
    if (initialTab) activate(initialTab);
  };

  const initAll = (scope) => {
    const rootList = (scope || document).querySelectorAll(ROOT_SELECTOR);
    if (!rootList.length) return;
    rootList.forEach(initOne);
  };

  document.addEventListener('DOMContentLoaded', () => initAll(document));

  document.addEventListener('shopify:section:load', (e) => {
    initAll(e.target);
  });
})();



///////////////////////////////////// 
// サンクスページ
/////////////////////////////////////
(() => {
  const THANKS_URL = "/pages/atelier-u-thanks";
  const FLAG_KEY = "atelieru_register_just_submitted";

  const isThanksPage = () => location.pathname === THANKS_URL;
  const isAccountPage = () =>
    location.pathname === "/account" || location.pathname === "/account/";
  const isRegisterPage = () => location.pathname === "/account/register";

  const markJustSubmitted = () => {
    try {
      sessionStorage.setItem(FLAG_KEY, "1");
    } catch (e) {}
  };

  const clearFlag = () => {
    try {
      sessionStorage.removeItem(FLAG_KEY);
    } catch (e) {}
  };

  const hasFlag = () => {
    try {
      return sessionStorage.getItem(FLAG_KEY) === "1";
    } catch (e) {
      return false;
    }
  };

  const registerForm = document.querySelector("#create-customer form");
  if (registerForm) {
    registerForm.addEventListener("submit", () => {
      markJustSubmitted();
    });
  }

  // 登録失敗（既登録メール等）で /account/register に戻ってきた場合はフラグをクリア
  if (isRegisterPage() && hasFlag()) {
    clearFlag();
    return;
  }

  if (isAccountPage() && hasFlag()) {
    clearFlag();
    location.replace('/account/register?error=already_registered');
    return;
  }

  if (isThanksPage()) {
    clearFlag();
  }
  })();



///////////////////////////////////// 
// SHOPPING GUIDE
/////////////////////////////////////
document.addEventListener('DOMContentLoaded', () => {
  const detailsList = document.querySelectorAll('.riu-acc');

  detailsList.forEach((details) => {
    const summary = details.querySelector('.riu-acc__summary');
    const content = details.querySelector('.riu-acc__content');
    if (!summary || !content) return;

    content.style.overflow = 'hidden';

    if (details.open) {
      content.style.height = 'auto';
    } else {
      content.style.height = '0px';
    }

    details.addEventListener('toggle', () => {
      if (!details.open) return;

      content.style.height = '0px';
      const target = content.scrollHeight;

      requestAnimationFrame(() => {
        content.style.transition = 'height 220ms ease';
        content.style.height = `${target}px`;
      });

      const onEnd = (e) => {
        if (e.propertyName !== 'height') return;
        content.removeEventListener('transitionend', onEnd);
        content.style.height = 'auto';
      };
      content.addEventListener('transitionend', onEnd);
    });

    summary.addEventListener('click', (e) => {
      if (!details.open) return;

      e.preventDefault();

      const current = content.getBoundingClientRect().height;
      content.style.height = `${current}px`;

      requestAnimationFrame(() => {
        content.style.transition = 'height 220ms ease';
        content.style.height = '0px';
      });

      const onEnd = (ev) => {
        if (ev.propertyName !== 'height') return;
        content.removeEventListener('transitionend', onEnd);
        details.open = false;
      };
      content.addEventListener('transitionend', onEnd);
    });
  });
});



///////////////////////////////////// 
// 再入荷通知ボタンを移動
/////////////////////////////////////

(function () {
  function moveRestockBtn() {
    var restockBtn = document.getElementById('_ngc_stock_notice_btn');
    var atcWrapper = document.querySelector('.quantity-submit-row__submit');

    if (restockBtn && atcWrapper) {
      atcWrapper.insertAdjacentElement('afterend', restockBtn);
      return true;
    }
    return false;
  }

  if (!moveRestockBtn()) {
    var observer = new MutationObserver(function () {
      if (moveRestockBtn()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();




///////////////////////////////////// 
// 住所変更ページの都道府県順番変更
/////////////////////////////////////
const JP_PROVINCE_ORDER = [
  '北海道','青森県','岩手県','宮城県','秋田県','山形県','福島県',
  '茨城県','栃木県','群馬県','埼玉県','千葉県','東京都','神奈川県',
  '新潟県','富山県','石川県','福井県','山梨県','長野県','岐阜県',
  '静岡県','愛知県','三重県','滋賀県','京都府','大阪府','兵庫県',
  '奈良県','和歌山県','鳥取県','島根県','岡山県','広島県','山口県',
  '徳島県','香川県','愛媛県','高知県','福岡県','佐賀県','長崎県',
  '熊本県','大分県','宮崎県','鹿児島県','沖縄県'
];

function reorderJapanProvinces(selectEl) {
  const options = Array.from(selectEl.options);
  if (options.length === 0) return;
  const sorted = options.sort((a, b) => {
    const ai = JP_PROVINCE_ORDER.indexOf(a.text);
    const bi = JP_PROVINCE_ORDER.indexOf(b.text);
    if (ai === -1 && bi === -1) return 0;
    if (ai === -1) return 1;
    if (bi === -1) return -1;
    return ai - bi;
  });
  sorted.forEach(opt => selectEl.appendChild(opt));
}

// country-province-selectorがDOMを更新した後に実行
document.addEventListener('change', (e) => {
  if (e.target.matches('.js-country-select')) {
    setTimeout(() => {
      const container = e.target.closest('country-province-selector');
      if (!container) return;
      const provinceSelect = container.querySelector('.js-province-select');
      if (provinceSelect) reorderJapanProvinces(provinceSelect);
    }, 100);
  }
});

// 初期表示時（既存住所の編集フォーム）
document.querySelectorAll('.js-province-select').forEach(reorderJapanProvinces);



/////////////////////////////////////
// 商品詳細　動画
/////////////////////////////////////
document.addEventListener('DOMContentLoaded', () => {
  const video = document.querySelector('.product-video video');

  if (!video) return;

  video.pause = function () {};

  video.muted = true;

  const playPromise = video.play();

  if (playPromise !== undefined) {
    playPromise.catch(() => {});
  }
});

/////////////////////////////////////
// 閉鎖ページ以外をTOPへ転送
/////////////////////////////////////
(() => {
  const isThemeEditor =
    window.Shopify && window.Shopify.designMode;

  const isTopPage =
    document.body.classList.contains('template-index');

  const isChallengePage =
    window.location.pathname === '/challenge';

  if (!isThemeEditor && !isTopPage && !isChallengePage) {
    window.location.replace('/');
  }
})();